import React from 'react'
import styled from 'styled-components'

import { ButtonUnstyled } from '../Button'
import { Tooltip } from '../Tooltip'

import { ReactComponent as EyeIcon } from '@sketch/icons/eye-24'
import { ReactComponent as EyeStrikeIcon } from '@sketch/icons/eye-strikethrough-24'

interface TogglePasswordButtonProps {
  showPassword?: boolean
}

export const TogglePasswordButton = styled(ButtonUnstyled).attrs({
  type: 'button',
})<TogglePasswordButtonProps>`
  /* The right padding on StyledPasswordInput and PreviewPasswordInput is calculated
    based on the size and right position of this button. Update those accordingly if
    one of them changes here. */
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 40px;
  width: 48px;

  svg {
    opacity: 0.55;
  }

  ${({ showPassword, theme }) =>
    showPassword &&
    `
    background-color: ${
      theme._name === 'dark' ? theme.colors.sketch.D : theme.colors.sketch.F
    };
    svg {
    color: ${
      theme._name === 'dark' ? theme.colors.foreground.secondary.A : undefined
    }
    }
    border-radius: 6px;
  `}
`

const StrikeEyeIcon = styled(EyeStrikeIcon)`
  color: ${({ theme }) => theme.colors.sketch.A};
`

interface ToggleShowPasswordButtonProps {
  onClick: () => void
  showPassword: boolean
  disabled?: boolean
}

export const ToggleShowPasswordButton: React.FCC<
  ToggleShowPasswordButtonProps
> = ({
  onClick,
  showPassword,
  disabled = false,
}: ToggleShowPasswordButtonProps) => {
  return (
    <Tooltip
      content={showPassword ? 'Hide password' : 'Show password'}
      placement="bottom"
    >
      {/* Use render prop pattern to attach ref directly to button (not a wrapper div)
          so tooltip positions relative to the absolutely positioned button */}
      {props => (
        <TogglePasswordButton
          data-testid="eye-icon"
          onClick={onClick}
          disabled={disabled}
          showPassword={showPassword}
          {...props}
        >
          {showPassword ? (
            <StrikeEyeIcon
              width={17}
              height={17}
              focusable={false}
              aria-hidden={true}
            />
          ) : (
            <EyeIcon
              width={17}
              height={17}
              focusable={false}
              aria-hidden={true}
            />
          )}
        </TogglePasswordButton>
      )}
    </Tooltip>
  )
}
